<template>
    <li class="nav-item" :class="{'active' : isActive}" v-if="data && data.menus && data.menus.length > 0">
        <a class="nav-link" :class="{'collapsed': show, 'sidebar-collapsed': sidebar.mini && !sidebar.mobile}" data-toggle="collapse" :aria-expanded="`${show}`" @click="toggle">
            <i :class="data.icon" v-if="data.icon"></i>
            <p :class="{'hide-paragraph': sidebar.mini && !sidebar.mobile}">
                {{$t(data.code)}}
                <b class="caret" v-if="data.menus && data.menus.length > 0"></b>
            </p>
        </a>
        <div class="collapse" :class="{'show': show}" v-if="data.menus && data.menus.length > 0">
            <ul class="nav">
                <template v-for="menu in data.menus">
                    <router-link v-if="hasPermission(menu.permission)" tag="li" :to="menu.link" class="nav-item" active-class="active" :key="menu.name">
                        <a class="nav-link" :class="{'sidebar-collapsed': sidebar.mini && !sidebar.mobile}">
                            <span class="sidebar-mini">{{$t(menu.shortCode)}}</span>
                            <p :class="{'hide-paragraph': sidebar.mini && !sidebar.mobile}">{{$t(menu.code)}}</p>
                        </a>
                    </router-link>
                </template>
            </ul>
        </div>
    </li>
    <router-link tag="li" :to="data.link" class="nav-item" active-class="active" v-else>
        <a class="nav-link" :class="{'sidebar-collapsed': sidebar.mini && !sidebar.mobile}">
            <i :class="data.icon" v-if="data.icon"></i>
            <p :class="{'hide-paragraph': sidebar.mini && !sidebar.mobile}">{{$t(data.code)}}</p>
        </a>
    </router-link>
</template>

<script>

    import {mapState} from 'vuex';

    export default {
        name: "SidebarMenu",
        props: {
            data: Object
        },
        data() {
            return {
                show: false
            }
        },
        computed: {
            isActive() {
                let contains = false;
                if (this.data && this.data.menus && this.data.menus.length > 0) {
                    for (let i = 0; i < this.data.menus.length; i++) {
                        if (this.data.menus[i].name && this.data.menus[i].name === this.$route.name) {
                            contains = true;
                        }
                    }
                }
                return contains;
            },
            ...mapState(['sidebar'])
        },
        methods: {
            toggle() {
                this.show = !this.show;
            }
        }
    }
</script>

<style scoped>

</style>